import { cn } from '@/lib/utils';
import { ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';
import { TIF_OPTIONS } from '../api/create-order';

type Props = {
  value?: string;
  onChange: (value: string) => void;
};

export default function TIFSelect({ value, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="relative">
      <button
        className={cn(
          'flex h-9 w-full items-center justify-between gap-2 bg-vestgrey-800 px-2 py-1 text-center font-mono transition-colors hover:bg-border',
          !!value && 'text-foreground',
        )}
        onClick={(e) => {
          setIsOpen(!isOpen);
          e.preventDefault();
        }}
      >
        {value || '-'}
        <ChevronDownIcon
          size={14}
          className={cn('text-vestgrey-200 transition-transform duration-300', {
            'rotate-180': isOpen,
          })}
        />
      </button>
      {isOpen && (
        <div className="absolute left-auto right-0 top-full z-10 w-min overflow-hidden border border-border bg-vestgrey-900 shadow-lg">
          {TIF_OPTIONS.map((opt) => (
            <button
              type="button"
              className="w-full cursor-pointer border-b border-border px-4 py-2 font-mono uppercase text-foreground last:border-b-0 hover:bg-vestgrey-800"
              onClick={() => {
                onChange(opt);
                setIsOpen(false);
              }}
              key={opt}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
